import React from 'react';

import Card from '../layout/Card';
import { Eye } from "lucide-react";
import InfoCardItem from './InfoCardItem';


const TableItems = ({ label, data, total }) => {

    return (
        <>
            <div className='df jcsb'>
                <p className='fr cw mb1'>{label}</p>
                <p className='fb cw df aic'><span className='mr1'><Eye size={15} color='#fff' /></span>{" "}{total}</p>
            </div>
            {data?.length > 0 && data.map((item, item_i) => (
                <div className='mb1' key={item_i + "_film"}>
                    <Card>
                       <InfoCardItem item={item} item_i={item_i} />
                    </Card>
                </div>
            ))}
        </>
    );
};

export default TableItems;